const SAMPLE_BUCKET_MODULO = 100

const sanitizeSampleRate = (sampleRate: number): number => {
  if (!Number.isFinite(sampleRate)) return 0
  if (sampleRate < 0) return 0
  if (sampleRate > 100) return 100
  return Math.floor(sampleRate)
}

const hashString = (value: string): number => {
  let hash = 0
  for (let index = 0; index < value.length; index += 1) {
    hash = (hash * 31 + value.charCodeAt(index)) | 0
  }
  return Math.abs(hash)
}

export const isInThanksSample = (
  sampleSeed: string,
  sampleRate: number,
): boolean => {
  const boundedSampleRate = sanitizeSampleRate(sampleRate)
  if (boundedSampleRate === 0) return false
  if (boundedSampleRate === 100) return true

  const bucket = hashString(sampleSeed) % SAMPLE_BUCKET_MODULO
  return bucket < boundedSampleRate
}
